import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_6 = { class: "dataTable" }
const _hoisted_7 = { class: "headerWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('administratif.request.title')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "tagNfc.definition" })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isUniqueSite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                    _createVNode(_component_ButtonBlue, {
                      "on-click": _ctx.selectionnerSite,
                      text: _ctx.$t('bouton.choix.site'),
                      class: "button-confirm btn",
                      disabled: _ctx.tableData.length === 0 && _ctx.isLoading
                    }, null, 8, ["on-click", "text", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Filter, {
                onSearch: _ctx.doFilter,
                onSetLocalisation: this.setLocalisation,
                onClearFilter: this.clearFilter,
                filter: this.filter,
                searchSite: _ctx.searchSite
              }, null, 8, ["onSearch", "onSetLocalisation", "onClearFilter", "filter", "searchSite"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(_ctx.$tc('administratifRequest.dataTable.title', +_ctx.count)) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "tagNfc.portee" })
                ]),
                (!_ctx.isExportDisabled)
                  ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                      key: 0,
                      onClick: _ctx.exportXls,
                      imgUrl: _ctx.iconeXls,
                      title: _ctx.$t('list.export')
                    }, null, 8, ["onClick", "imgUrl", "title"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.tableData.length === 0 && _ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                    key: 0,
                    class: "loader"
                  }))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                    ref: "content",
                    class: "datatable-container"
                  }, [
                    _createVNode(_component_DataTable, {
                      count: +_ctx.count,
                      tableData: this.tableData,
                      isLoading: _ctx.isLoading,
                      tableHeader: this.tableHeader,
                      noDataText: _ctx.$t('search.notFound'),
                      onSort: _ctx.doSort,
                      onSelect: _ctx.getHistorique
                    }, null, 8, ["count", "tableData", "isLoading", "tableHeader", "noDataText", "onSort", "onSelect"])
                  ], 544))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 1,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite,
          "selected-site": null,
          "selected-sites": _ctx.filter.siteList,
          "is-multi-site": true
        }, null, 8, ["onCancel", "onValider", "selected-sites"])),
    (_ctx.isModalHistoriqueOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isModalHistoriqueOpen = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isModalHistoriqueOpen = false)),
              noPaddingTop: false,
              withoutBotNav: true,
              headerTitle: _ctx.$t('administratif.navigation.nfc.historique'),
              "active-validate": false,
              "is-pop-up-table": true,
              "fixed-size": true
            }, {
              "header-append": _withCtx(() => [
                _createVNode(_component_ReglePastille, {
                  cle: "tagNfc.historique",
                  placement: "bottom"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleHistoriqueScroll && _ctx.handleHistoriqueScroll(...args))),
                  ref: "contentHisto",
                  class: "datatable-historique-container"
                }, [
                  _createVNode(_component_DataTable, {
                    count: +_ctx.count,
                    tableData: this.historiqueTableData,
                    isLoading: _ctx.isHistoriqueLoading,
                    tableHeader: this.historiqueTableHeader,
                    noDataText: _ctx.$t('search.notFound'),
                    onSort: _ctx.doSortHistorique
                  }, null, 8, ["count", "tableData", "isLoading", "tableHeader", "noDataText", "onSort"])
                ], 544)
              ]),
              _: 1
            }, 8, ["headerTitle"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}